import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { CloseThick } from '@withjoy/joykit/icons';
import type { TagVariant, TagIntent } from './';

const getOutlinedVariantStyles = (props: ContainerProps): StyleSystemProps => {
  return {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'primary8',
    color: 'primary8',
    ...(props.isInteractive
      ? {
          _hover: {
            backgroundColor: 'primary2',
            cursor: 'pointer',
          },
          _active: {
            backgroundColor: 'mono3',
          },
        }
      : undefined),
  };
};

const getSolidVariantStyles = (props: ContainerProps): StyleSystemProps => {
  return {
    backgroundColor: 'mono3',
    color: 'mono14',
    ...(props.isInteractive
      ? {
          _hover: {
            backgroundColor: 'mono2',
            color: 'primary6',
            cursor: 'pointer',
          },
          _active: {
            backgroundColor: 'mono4',
          },
        }
      : undefined),
  };
};

type ContainerProps = { isInteractive: boolean; variant: TagVariant; intent: TagIntent; disabled?: boolean };

const deleteContainerStyles = {
  cursor: 'pointer',
  marginLeft: '0.5rem',
  transition: animationTransition('color'),
  _hover: {
    color: 'primary6',
  },
  _active: {
    color: 'primary8',
  },
};

const containerStyles = (props: ContainerProps): StyleSystemProps => {
  return {
    cursor: 'pointer',
    alignItems: 'center',
    borderRadius: '15px',
    display: 'inline-flex',
    flexDirection: 'row',
    minHeight: '2rem',
    outline: 'none',
    paddingY: 0,
    paddingX: '1rem',
    marginRight: '0.5rem',
    marginLeft: 0,
    marginY: 0,
    whiteSpace: 'nowrap',
    transition: animationTransition('background-color', 'color', 'border'),
    ...(props.variant === 'outlined' ? getOutlinedVariantStyles(props) : getSolidVariantStyles(props)),
  };
};

export const styles = {
  containerStyles,
  deleteContainerStyles,
};

export const StyledContainer = styled(Box)``;
export const StyledDeleteContainer = styled(CloseThick)``;
